<main>
    <div class="app app-margin bgImg" >
        <div class="card successbox pad10 cur-def" *ngIf="showSuccessMessage" >
            <div class="header vertical-center">
              <div class="left flexStart" [dir]="textDir">
                <div class="icon-holder eds-green" >
                     <div class="vertical-center" ><i class="icon icon-check"></i></div>
               
                     </div>
                    <div class="font14 padL10 padT2 marT5">{{successMessage}}</div>
              </div>
            </div>
          </div>
        <div class="loginbox vertcl-center" [ngClass]="showSuccessMessage?'dynamic-top':''" [dir]="textDir">
            <div class="loginWindow">
                <div class="top">
                    <div class="econFont" ><i class="icon icon-econ"></i></div>

                    <div class="loginheader marT20" >{{'Ericsson Connect to Learn' | translate}} </div>
                 </div>
                <div >
                    <!-- <h4>Login to your account</h4> -->
                    <label class="logintitle marT20" *ngIf="isConsented">{{'Language' | translate}}</label>
                    <span class="item light">
                        <div class="select" data-type="single" style="width: 100%;margin-top:10px;">
                            <button class="btn current-options" style="height:32px;">{{selectedLanguage}}</button>                      
                            <div class="options-list">
                                <div class="item" [class.active]="selectedLanguage==languageConfiguration.languageFullname.ar" (click)="setLanguage('ar','rtl')">{{languageConfiguration.languageFullname.ar}}</div>
                                <div class="item" [class.active]="selectedLanguage==languageConfiguration.languageFullname.en"  (click)="setLanguage('en' ,'ltr')">{{languageConfiguration.languageFullname.en}}</div>
                                <div class="item" [class.active]="selectedLanguage==languageConfiguration.languageFullname.fr" (click)="setLanguage('fr','ltr')">{{languageConfiguration.languageFullname.fr}}</div>
                                <div class="item" [class.active]="selectedLanguage==languageConfiguration.languageFullname.hi"  (click)="setLanguage('hi','ltr')">{{languageConfiguration.languageFullname.hi}}</div>
                                <div class="item" [class.active]="selectedLanguage==languageConfiguration.languageFullname.pt" (click)="setLanguage('pt','ltr')">{{languageConfiguration.languageFullname.pt}}</div>
                                <div class="item" [class.active]="selectedLanguage==languageConfiguration.languageFullname.sp" (click)="setLanguage('sp','ltr')">{{languageConfiguration.languageFullname.sp}}</div>

                            </div>
                        </div>    
                    </span>
                    
                    <label class="logintitle marT20" *ngIf="isConsented">{{'title' | translate}}</label>
                    <h4 class="logintitle" *ngIf="!isConsented">{{'Welcome' | translate}}</h4>
                    <form [formGroup]="loginForm" id="loginform" class="form-horizontal marT20" role="form" (ngSubmit)="onLoginFormSubmit()" *ngIf="isConsented">
                        <!-- <dl> -->
                        <div class="marT10 hgt30">                          
                            <input  class="marB10 eds-fullwidth labeltxt" [ngClass]="alertMessage?'err-border':''" placeholder="{{'Enter your domain\\username' | translate}}" type="text" id="uname" value=""
                                formControlName='userName' (change)='resetAlertMsg()' (input)='resetSuccesstMsg()' [dir]="textDir"/>                           
                        </div>
                        <div class="marT10 hgt30" >                           
                            <input [dir]="textDir" class="marB10 eds-fullwidth labeltxt" [ngClass]="alertMessage?'err-border':''" placeholder="{{'Enter your password' | translate}}" type="password" id="pwd" value="" formControlName='passWord' in>         
                        </div>
                        <!-- </dl> -->
                        <div class="marT20">
                            <!-- Button -->
                            <div >
                                <p class="error-message" *ngIf="alertMessage"> {{'Error' | translate}}: {{alertMessage}}</p>
                            </div>
                            <p class="font12" *ngIf="!alertMessage">{{'This application works best in Mozilla Firefox'| translate}}</p>
                            
                            <label class="font12" >{{'contact your administrator'| translate}} </label>
                            
                            <div class="marT30 flexEnd">
                                <button type="submit" class="btn primary loginbtn" [disabled]="!loginForm.valid"  [ngClass]="{disabled : !loginForm.valid, enabled:loginForm.valid}" >{{'Login'| translate}}</button>
                            </div>
                        </div>
                    </form>
                    <form [formGroup]="consentForm" id="consentForm" class="form-horizontal" role="form" (ngSubmit)="onConsentFormSubmit()" *ngIf="!isConsented">
                        <div class="form-group">
                            <label class="labeltxt marT20">{{data.userName}}</label> 
                            <label class="labeltxt marT15">{{'data will be processed' | translate}}</label>                                           
                        </div>
                        <div class="form-group ">                           
                            <div class="marT20 flexStart">
                                <input class="ng-pristine ng-valid ng-touched marginL8" formControlName="consent" style="cursor: pointer;" type="checkbox"> 
                                <label class="labeltxt">{{'consent to the processing' | translate}} <a href="#" id="open-simple" (click)="openConsent()">{{'here' | translate}}</a></label>
                            </div>  
                            <div class="marT20 eds-fullwidth flexEnd" >
                                <button type="submit" class="btn primary" [disabled]="!consentForm.valid" [ngClass]="{disabled : !consentForm.valid, enabled:consentForm.valid}">Login</button>
                            </div>  
                        </div>
                    </form>
                </div>
            </div>
            <div class="bottom">                          
                <div class="eric-white">{{'copyright' | translate}}</div>
             </div>
        </div>
    </div>

    <!-- Consent modal -->
    
<div #consentDialog class="dialog view-consent-dialog" data-trigger="#open-simple" data-type="simple">
    <div class="content">
        <div class="dialog-title">{{'Privacy notice and consent' | translate}}</div>
          <div class="body">
            <label class="labeltxt">{{'Data controller' | translate}} <a class="link-txt" target="_blank" rel="noopener noreferrer" href="https://www.ericsson.com/en/legal/privacy">www.ericsson.com/en/legal/privacy</a></label>                
            <label class="labeltxt">{{'Your personal data' | translate}}</label>                 
            <label class="labeltxt">{{'Processing is necessary' | translate}} </label>                
            <label class="labeltxt">{{'data is processed' | translate}} <a class="link-txt" target="_blank" rel="noopener noreferrer" href="https://www.ericsson.com/en/legal/privacy/controller-binding-corporate-rules">https://www.ericsson.com/en/legal/privacy/controller-binding-corporate-rules</a></label>                
            <label class="labeltxt">{{'data will be stored' | translate}}</label>                
            <label class="labeltxt">{{'You have the right' | translate}} </label>                
            <label class="labeltxt padB20">{{'By selecting the consent' | translate}} </label>
          </div>
          <div class="bottom">           
              <button class="btn primary" data-close="true" (click)="closeConsent()">{{'Close' | translate}}</button>
          </div>
    </div>
</div>
<!-- Consent modal end -->
</main>
